<template lang="pug">
  div.environment-dashboard
    transition(name='slide-fade-down' mode='out-in' appear)
      MapToolsGeneric(ref='toolsGeneric'  @updateFilter='updateFilter' @zoomParque='zoomParque' verticalType="parksandgardens" )
    transition(name='fade')
      LegendMap(:verticalType='tabsVertical' :dataLengend='listParks[tabsVertical].legend' :datosFinal='dataParkingPanels2' :dataParkingCurrent='dataParkingCurrent' ref="legendMap")
    MapZoomParks(v-if='compare' slot="tools" @zoomParque='zoomParque' ref='mapZoom')
    transition(name='fadeSlide' appear)
      PanelDashboard(ref="panelDashboard")
        VerticalGeneric(
          slot="container"
          ref='verticalGeneric'
          @updateKpiGeneric='updateKpiGeneric'
          @setPopupParking='setPopupParking'
          :verticalType='tabsVertical')
        MapZoomParks.panel-dashboard__tools.panel-dashboard__tools--bottom-left-out(
          slot="tools"
          ref='mapZoom'
          )
        SearchMap.panel-dashboard__search.panel-dashboard__search--top-left-out(
          slot="search"
          ref="mapSearch"
        )
</template>

<script>
import VerticalGeneric from '@/views/VerticalGeneric'
import PanelDashboard from '@/components/PanelDashboard'
import MapCompare from '@/components/MapCompare'
import MapZoomParks from '@/components/MapZoomParks'
import MapToolsGeneric from '@/components/MapToolsGeneric'
import mapChartsElements from '@/mixins/mapChartsElements'
import PopupCompare from '@/components/PopupCompare'
import SearchMap from '@/components/SearchMap'
import LegendMap from '@/components/LegendMap'

import jsonGisAreaInfluence from '@/moks/las_palmas/parksandgardens/gisAreaInfluence'
import jsonGisCounters from '@/moks/las_palmas/parksandgardens/gisCounters'
import jsonGisGround from '@/moks/las_palmas/parksandgardens/gisGround'
import jsonGisIncidence from '@/moks/las_palmas/parksandgardens/gisIncidence'
import jsonGisParkInformation from '@/moks/las_palmas/parksandgardens/gisParkInformation'
import jsonGisValves from '@/moks/las_palmas/parksandgardens/gisValves'

export default {
  name: 'ParksAndGardensDashboard',
  data () {
    return {
      opened: false,
      compare: false,
      mapLoad: false,
      dataSoilSensors: null,
      dataIncidences: null,
      dataFlowmeters: null,
      dataElectrovalves: null,
      dataCo2Absorption: null,
      dataParks: null,
      dataPolygonParks: null,
      datosFinal: [],
      dataCompare: true,
      dataCompareLoad: true,
      stationName: null,
      valorComparado: null,
      tabsVertical: 'Parksandgardens',
      listParks: {
        Parksandgardens: {
          name: 'Parksandgardens',
          value: 'Parksandgardens',
          label: 'Parksandgardens',
          breadcumb: 'Parksandgardens',
          listCategory: [
            {
              value: 'dataSourceParkInformation',
              label: 'Informacióndeparques',
              show: true
            },
            {
              value: 'dataSourceGround',
              label: 'Informacióndesuelo',
              show: true
            },
            {
              value: 'dataSourceCounters',
              label: 'Contadores',
              show: true
            },
            {
              value: 'dataSourceValves',
              label: 'Electrovalvulas',
              show: true
            },
            {
              value: 'dataSourceIncidence',
              label: 'Incidencias',
              show: true
            },
            {
              value: 'dataSourcePoligonoParque',
              label: 'AreadeInfluencia',
              show: true
            }
          ],
          listCategorySelected: ['dataSourceParkInformation', 'dataSourceGround', 'dataSourceCounters', 'dataSourceValves', 'dataSourceIncidence', 'dataSourcePoligonoParque'],
          legend: [
            {
              label: 'Información de parques',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_park_green.svg',
              type: 'point'
            },
            {
              label: 'Información de suelo',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_soilSensor_brown.svg',
              type: 'point'
            },
            {
              label: 'Contadores',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_flowmeter_blue.svg',
              type: 'point'
            },
            {
              label: 'Electrovalvulas',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_electrovalve_violet.svg',
              type: 'point'
            },
            {
              label: 'Incidencias',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_warning_red.svg',
              type: 'point'
            },
            {
              label: 'Area de Influencia',
              img: process.env.BASE_URL + '/clm-demo/static/resources/GIS_V18/img/icon_noise_pink.svg',
              type: 'point'
            }
          ]
        }
      },
      dataParkingPanels2: {},
      dataParkingCurrent: {}
    }
  },
  mixins: [mapChartsElements],
  methods: {
    init () {
      const vm = this
      var myLoadMap = () => {
        let encontrado = false
        if (vm.mapLoad === true) {
          document.getElementById('dataIframe').contentWindow.mapClear()
          let selectArray = vm.listParks[vm.tabsVertical].listCategory
          selectArray.forEach(elem => {
            // 'dataSourceSensorZones', 'dataSourceParking', 'dataSourcePanelParking'
            document.getElementById('dataIframe').contentWindow.viewer.dataSources._dataSources
              .filter((data) => data._name.name === elem.value)
              .map((valor) => {
                valor.show = true
                encontrado = true
                return valor
              })
          })
          if (!encontrado) {
            vm.createLayerGIs('AreaInfluence')
            vm.createLayerGIs('Incidence')
            vm.createLayerGIs('Valves')
            vm.createLayerGIs('Counters')
            vm.createLayerGIs('ParkInformation')
            vm.createLayerGIs('Ground')
          }
          vm.controlPage()
          clearInterval(myLoadMapElem)
        }
      }
      var myLoadMapElem = setInterval(myLoadMap, 500)
    },
    createLayerGIs (category, val) {
      let simb = ''
      let simbSelect = ''
      let simbIsolated = ''
      switch (category) {
        case 'AreaInfluence':
          jsonGisAreaInfluence.name = 'PoligonoParque'
          document
            .getElementById('dataIframe')
            .contentWindow.createLayer(
              jsonGisAreaInfluence,
              'parques',
              'polygon',
              'entity',
              'simple',
              'green',
              0.2
            )
          break
        case 'Incidence':
          simb = 'img/icon_warning_red.svg'
          simbSelect = 'img/icon_warning_white.svg'
          simbIsolated = 'ods-icon-icon_warning_isolated'
          document
            .getElementById('dataIframe')
            .contentWindow.createLayer(
              jsonGisIncidence,
              'parksandgardens',
              'point',
              'entity',
              'billboard',
              simb,
              simbSelect,
              simbIsolated,
              0.8)
          break
        case 'Ground':
          simb = 'img/icon_soilSensor_brown.svg'
          simbSelect = 'img/icon_soilSensor_white.svg'
          simbIsolated = 'ods-icon-icon_soilSensor_isolated'
          document
            .getElementById('dataIframe')
            .contentWindow.createLayer(
              jsonGisGround,
              'parksandgardens',
              'point',
              'entity',
              'billboard',
              simb,
              simbSelect,
              simbIsolated,
              0.8)
          break
        case 'Counters':
          simb = 'img/icon_flowmeter_blue.svg'
          simbSelect = 'img/icon_flowmeter_white.svg'
          simbIsolated = 'ods-icon-icon_flowmeter_isolated'
          document
            .getElementById('dataIframe')
            .contentWindow.createLayer(
              jsonGisCounters,
              'parksandgardens',
              'point',
              'entity',
              'billboard',
              simb,
              simbSelect,
              simbIsolated,
              0.8)
          break
        case 'ParkInformation':
          simb = 'img/icon_park_green.svg'
          simbSelect = 'img/icon_park_white.svg'
          simbIsolated = 'ods-icon-icon_parks_detail'
          document
            .getElementById('dataIframe')
            .contentWindow.createLayer(
              jsonGisParkInformation,
              'parksandgardens',
              'point',
              'entity',
              'billboard',
              simb,
              simbSelect,
              simbIsolated,
              0.8)
          break
        case 'Valves':
          simb = 'img/icon_electrovalve_violet.svg'
          simbSelect = 'img/icon_electrovalve_white.svg'
          simbIsolated = 'ods-icon-icon_electrovalve_isolated'
          document
            .getElementById('dataIframe')
            .contentWindow.createLayer(
              jsonGisValves,
              'parksandgardens',
              'point',
              'entity',
              'billboard',
              simb,
              simbSelect,
              simbIsolated,
              0.8)
          break
      }
    },
    controlPage () {
      const component = this
      this.$refs.toolsGeneric.clearFilter()
      component.cleanAndLoadDataGis()
    },
    cleanAndLoadDataGis () {
      const component = this
      var category = []
      var categorySelected = []
      var myLoadMap = () => {
        if (component.mapLoad === true && component.$refs.toolsGeneric !== undefined) {
          document.getElementById('dataIframe').contentWindow.mapClear()
          category = component.listParks[component.tabsVertical].listCategory
          categorySelected = component.listParks[component.tabsVertical].listCategorySelected
          component.$refs.toolsGeneric.setToolsGeneric(
            category,
            categorySelected
          )
          component.loadDataFilter()
          component.$refs.verticalGeneric.updateKpis(categorySelected, component.tabsVertical)
          clearInterval(myLoadMapElem)
        }
      }
      var myLoadMapElem = setInterval(myLoadMap, 500)
    },
    loadDataFilter () {
      document.getElementById('dataIframe').contentWindow.activarDesactivarCapa(this.listParks[this.tabsVertical].listCategory)
    },
    updateFilter (category, categorySelected) {
      this.$refs.verticalGeneric.updateKpis(category, this.tabsVertical)
    },
    setPopupParking (val, data, type, currentKpi) {
      this.$refs.legendMap.open = this.$refs.legendMap.data = true
      this.openedParking = val
      this.dataParkingPanels = []
      this.dataParkingPanels = data
      this.dataParkingPanels2 = data
      this.dataParkingCurrent = currentKpi
    },
    updateKpiGeneric () {
      const component = this
      // var category, categorySelected
      let categorySelected = []
      // category = component.$refs.toolsGeneric.getDataCategory()
      categorySelected = component.$refs.toolsGeneric.getCaterogySelected()
      component.$refs.verticalGeneric.updateKpis(categorySelected, this.tabsVertical)
    },
    updateStationCompare (data) {
      this.stationName = data[0]
      this.valorComparado = data[1]
      this.dataCompare = data[2]
      this.dataCompareLoad = data[3]
      this.datosFinal = data[4]
      // this.opened = true
    },
    showCompare () {
      const component = this
      if (component.$route.path === '/ParksAndGardens/ParksAndGardensCompare') {
        component.compare = true
        // alert('asd')
        // this.$forceUpdate();
      } else {
        component.compare = false
        // this.$forceUpdate();
      }
    },
    getStation (data) {
      const component = this
      if (component.$refs.park) {
        component.$refs.park.getSelectedStation(data)
      }
      if (component.$refs.compare) {
        component.$refs.compare.getSelectedStation(data)
      }
    },
    showAlertMap (data) {
      this.$refs.map.showAlerts(data, 'parques')
    },
    changeSelectedKpi (val) {
      this.$refs.park.updateControlSelected(val)
    },
    zoomParque (value) {
      document.getElementById('dataIframe').contentWindow.zoomParque(value)
    },
    setMapLoad () {
      this.mapLoad = true
      // this.$refs.mapSearch.changeBasemap()
    },
    setPopupCompare (val) {
      this.opened = val
    }
  },
  components: {
    VerticalGeneric,
    PanelDashboard,
    MapCompare,
    MapZoomParks,
    MapToolsGeneric,
    PopupCompare,
    SearchMap,
    LegendMap
  },
  created () {
    // this.$store.dispatch('getAllStations')
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    document.getElementById('dataIframe').contentWindow.mapClear()
  }
}
</script>

<style lang="scss" scoped>

/deep/ .boxFilterCompare {
  ~ .mapzoom {
    display: block;
    position: absolute;
    margin: 0;
    z-index: 5;
    padding: 16px 10px;
    outline: none;
    right: 0;
    bottom: 0;
  }
  ~ .map-tools {
    //SE QUITA PORQUE EN PANTALLAS GRANDES NO DEJA SELECCIONAR PUNTOS EN LA LINEA DEL SELECTOR
    // width: calc(100% - 104px);
    > .ods-row {
      margin: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ParksAndGardensDashboard.vue